import { useEffect, useState } from 'react';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';

interface Options {
  refresh?: number;
}

export const useCurrentTime = ({ refresh = 1000 }: Options = {}) => {
  const [now, setNow] = useState(getTime());

  useEffect(() => {
    const intervalId = window.setInterval(() => setNow(getTime()), refresh);
    return () => window.clearInterval(intervalId);
  }, [refresh, setNow]);

  return {
    now,
    isYesterday,
    isToday,
  };
};

const getTime = () => Date.now();

export default useCurrentTime;
